/* eslint-disable prettier/prettier */
import coach1 from '../assets/images/Tamanna.jpg';
import coach2 from '../assets/images/coach2.png';
import coach3 from '../assets/images/coach3.png';
import coach4 from '../assets/images/coach4.png';
import coach5 from '../assets/images/coach5.png';
import coach6 from '../assets/images/Jonathan.jpg';
import coach7 from '../assets/images/Peter.jpg';
import coach8 from '../assets/images/Dharmesh.png';

export const coaches = [
	{
		id: 1,
		name: 'Tamanna Bhatia',
		experience: 'Facilitator',
		image: coach1,
		gradientColor: '#1C7C54',
	},
	{
		id: 2,
		name: 'Kalpesh Raichura',
		experience: 'Chief Facilitator',
		image: coach2,
		gradientColor: '#5B1871',
	},
	{
		id: 3,
		name: 'Terry Thomas',
		experience: 'Sr. Consultant and Coach',
		image: coach3,
		gradientColor: '#1C7C54',
	},
	{
		id: 4,
		name: 'Dr. Rupinder Kaur',
		experience: 'Founder - IOCM',
		image: coach4,
		gradientColor: '#5B1871',
	},
	{
		id: 5,
		name: 'Sanjeev Sarin',
		experience: 'Senior Coach',
		image: coach5,
		gradientColor: '#1C7C54',
	},
	{
		id: 6,
		name: 'Jonathan Passmore',
		experience: 'Academic Advisor',
		image: coach6,
		gradientColor: '#5B1871',
	},
	{
		id: 7,
		name: 'Prof. Peter Jackson',
		experience: 'Senior Advisor',
		image: coach7,
		gradientColor: '#1C7C54',
	},
	{
		id: 8,
		name: 'Dharmesh Shah',
		experience: 'Director - Training',
		image: coach8,
		gradientColor: '#5B1871',
	},
];
